export const GET_ADDS_DATA = 'addsData/getAddsData'
